import { ElementType } from "react";
import { cn } from "@/lib/utils";

interface AnimatedHeadingProps {
  /** Each string renders as its own masked, rising line. */
  lines?: string[];
  className?: string;
  as?: ElementType;
  /** Kept for API compatibility. */
  trigger?: "mount" | "inview";
  children?: React.ReactNode; //added by sudip
}

/**
 * Kinetic headline with a staggered line-by-line mask reveal — the site's
 * signature on-load moment.
 *
 * Each line sits in its own overflow-hidden track and rises into view. The
 * track uses internal padding (so tall display glyphs/descenders are never
 * clipped) cancelled by a negative margin (so visual line-spacing stays
 * tight). Driven by a pure CSS animation, so it always completes — critical
 * for the H1 — and collapses to an instant appearance under
 * prefers-reduced-motion. The semantic tag stays static for accessibility.
 */
export function AnimatedHeading({
  lines,
  className,
  as: Tag = "h1",
  children,
}: AnimatedHeadingProps) {
  if (lines && lines.length > 0) {
    return (
      <Tag className={cn("[text-wrap:balance]", className)}>
        {lines.map((line, i) => (
          <span
            key={i}
            className="-my-[0.16em] block overflow-hidden py-[0.2em]"
          >
            <span
              className="block animate-line-rise"
              style={{ animationDelay: `${0.1 + i * 0.12}s` }}
            >
              {line}
            </span>
          </span>
        ))}
      </Tag>
    );
  }

  return (
    <Tag className={cn("[text-wrap:balance]", className)}>
      <span className="block animate-line-rise">
        {children}
      </span>
    </Tag>
  );

  // return (
  //   <Tag className={cn("[text-wrap:balance]", className)}>
  //     { lines.map((line, i) => (
  //       <span
  //         key={i}
  //         className="-my-[0.16em] block overflow-hidden py-[0.2em]"
  //       >
  //         <span
  //           className="block animate-line-rise"
  //           style={{ animationDelay: `${0.1 + i * 0.12}s` }}
  //         >
  //           {line}
  //         </span>
  //       </span>
  //     ))}
  //   </Tag>
  // );
}
